import { useBackend } from "../../services";

export const useDeleteUser = () => {
  const { deleteRequest } = useBackend();
  const deleteUser = () => deleteRequest("user");
  return { deleteUser };
};
